<script setup>
const props=defineProps(['id']);
const {data}=await useFetch('/api/catalog/synonyms',{query:{id:props.id}});
</script>
<template><p v-if="data?.length" class="text-sm text-slate-500">Другие названия: {{data.join(', ')}}</p></template>
